//上传进度
const upload={
    state: {
        uploadVisible:false,             //控制是否显示
        uploadProgress:0,                //上传进度
    },
    mutations: {
        set_uploadVisible(state,value){
            state.uploadVisible=value;
        },
        set_uploadProgress(state,value){
            state.uploadProgress = value;
        }
    },
    actions: {
        setUploadVisible({commit},value){
            commit('set_uploadVisible',value);
        },
        setUploadProgress({commit},value){
            commit('set_uploadProgress',value);
        }
    }
};
export default  upload;
